(() => {
  const bundleStates = new Map();
  class EmberanteBundle extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.variants = JSON.parse(this.querySelector('[data-bundle-pricing]')?.textContent || '[]');
      this.key = `${this.dataset.section}:${this.dataset.product}`;
      const saved = bundleStates.get(this.key);
      const options = Array.from(this.querySelectorAll('.em-bundle-option'));
      const target = saved?.option || this.dataset.preselected;
      const selected = options.find(el => el.dataset.option === target) || options[0];
      if (selected) selected.querySelector('input[type=radio]').checked = true;
      if (saved) {
        for (const option of options) {
          option.querySelectorAll('select').forEach((select, index) => {
            const id = saved.variant === this.dataset.defaultVariant ? saved.variants?.[option.dataset.option]?.[index] : this.dataset.defaultVariant;
            if (Array.from(select.options).some(o => o.value === id && !o.disabled)) select.value = id;
          });
        }
      }
      this.addEventListener('change', () => this.refresh(), { signal: this.abort.signal });
      this.refresh();
    }
    disconnectedCallback() { this.abort?.abort(); }
    money(value) {
      return new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(value / 100);
    }
    refresh() {
      const active = this.querySelector('input[type=radio]:checked')?.closest('.em-bundle-option');
      const saved = {option:active?.dataset.option, variant:this.dataset.defaultVariant, variants:{}};
      this.querySelectorAll('.em-bundle-option').forEach(option => {
        option.classList.toggle('is-selected', option === active);
        const ids = Array.from(option.querySelectorAll('select')).map(s => s.value);
        saved.variants[option.dataset.option] = ids;
        const selection = ids.length ? ids : Array(Number(option.dataset.quantity)).fill(this.dataset.defaultVariant);
        const variants = selection.map(id => this.variants.find(v => String(v.id) === String(id))).filter(Boolean);
        const regular = variants.reduce((sum, v) => sum + v.price, 0);
        const compare = variants.reduce((sum, v) => sum + (option.dataset.compareMode === 'compare_price' ? Math.max(v.compare, v.price) : v.price), 0);
        const price = Math.max(0, Math.round(regular * (1 - Number(option.dataset.discount) / 100) - Number(option.dataset.fixed)));
        option.querySelector('[data-offer-price]').textContent = this.money(price);
        const compareNode = option.querySelector('[data-offer-compare]');
        compareNode.textContent = this.money(compare);compareNode.hidden = compare <= price;
      });
      bundleStates.set(this.key, saved);
      const productScope = this.closest('.shopify-section');
      const quantity = productScope?.querySelector('product-form-component [name=quantity]');
      if (quantity && active) {
        quantity.value = active.dataset.quantity;
        const event = new Event('quantity-selector:update', {bubbles:true});
        event.detail = {quantity:Number(active.dataset.quantity)};
        this.dispatchEvent(event);
      }
    }
    updateVariant(id) {
      if (!id) return;
      this.dataset.defaultVariant = String(id);
      this.querySelectorAll('select').forEach(select => {
        if (Array.from(select.options).some(option => option.value === String(id) && !option.disabled)) select.value = String(id);
      });
      this.refresh();
    }
    getSelection() {
      const option = this.querySelector('input[type=radio]:checked')?.closest('.em-bundle-option');
      if (!option) return null;
      const nativeVariant = this.closest('.shopify-section')?.querySelector('product-form-component [name=id]')?.value || this.dataset.defaultVariant;
      const selects = Array.from(option.querySelectorAll('select'));
      const ids = selects.length ? selects.map(s => s.value) : Array(Number(option.dataset.quantity)).fill(nativeVariant);
      const grouped = new Map();
      ids.forEach(id => grouped.set(id, (grouped.get(id) || 0) + 1));
      return Array.from(grouped, ([id, quantity]) => ({id, quantity}));
    }
  }
  customElements.define('emberante-bundle', EmberanteBundle);
  class PresentationSlider extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();this.abort = new AbortController();
      this.track = this.querySelector('.splide__list,.slider');
      if (!this.track) return;
      const splide = this.querySelector('.splide');
      splide?.classList.add('is-initialized','is-active');
      this.querySelectorAll('.animate--hidden').forEach(el => el.classList.remove('animate--hidden'));
      this.addEventListener('click', event => {
        const button = event.target.closest('button');if (!button) return;
        const prev = button.matches('[name=previous],.splide__arrow--prev');
        const next = button.matches('[name=next],.splide__arrow--next');
        if (prev || next) {
          const step = this.track.children[0]?.getBoundingClientRect().width || this.track.clientWidth;
          this.track.scrollBy({left:step*(prev ? -1:1),behavior:'smooth'});
        }
        if (button.matches('.slider-counter__link')) {
          const buttons = Array.from(this.querySelectorAll('.slider-counter__link'));
          const slide = this.track.children[buttons.indexOf(button)];
          if (slide) this.track.scrollTo({left:slide.offsetLeft-this.track.offsetLeft,behavior:'smooth'});
        }
        if (button.matches('.slideshow__autoplay')) {
          this.paused=!this.paused;button.setAttribute('aria-pressed',String(this.paused));
        }
      },{signal:this.abort.signal});
      const update = () => {
        const width=this.track.children[0]?.getBoundingClientRect().width || 1;
        const index=Math.round(this.track.scrollLeft/width);
        const counter=this.querySelector('.slider-counter--current');if(counter)counter.textContent=String(index+1);
        const total=this.querySelector('.slider-counter--total');if(total)total.textContent=String(this.track.children.length);
        this.querySelectorAll('.slider-counter__link').forEach((b,i)=>{b.classList.toggle('slider-counter__link--active',i===index);b.setAttribute('aria-current',i===index?'true':'false');});
      };
      this.track.addEventListener('scroll',update,{signal:this.abort.signal,passive:true});update();
      if ((this.dataset.autoplay==='true'||this.track.dataset.autoplay==='true')&&!matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer=setInterval(()=>{
          if(this.paused||this.matches(':hover,:focus-within'))return;
          const end=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2;
          this.track.scrollTo({left:end?0:this.track.scrollLeft+this.track.clientWidth,behavior:'smooth'});
        },Number(this.dataset.autoplaySpeed||this.track.dataset.speed||5)*1000);
      }
    }
    disconnectedCallback(){this.abort?.abort();clearInterval(this.timer);}
  }
  ['em-slideshow-component','em-slider-component','em-splide-component'].forEach(name=>customElements.define(name,class extends PresentationSlider{}));
  class DeferredMedia extends HTMLElement {
    connectedCallback(){this.onclick=()=>{const template=this.querySelector('template');if(!template)return;this.append(template.content.cloneNode(true));template.remove();this.querySelector('button')?.remove();this.setAttribute('loaded','');this.querySelector('video')?.play().catch(()=>{});};}
  }
  customElements.define('em-deferred-media',DeferredMedia);
  customElements.define('em-localization-form',class extends HTMLElement {
    connectedCallback(){this.onclick=e=>{const link=e.target.closest('[data-value]');if(!link)return;e.preventDefault();const form=this.querySelector('form');const input=form?.querySelector('[name=country_code],[name=language_code]');if(input){input.value=link.dataset.value;form.requestSubmit();}};this.onchange=e=>{if(e.target.matches('select'))e.target.closest('form')?.requestSubmit();};}
  });
  const init=()=>{
    document.querySelectorAll('.emberante-legacy .animate--hidden').forEach(e=>{e.classList.remove('animate--hidden');e.classList.add('animate--shown');});
    document.querySelectorAll('.emberante-legacy [data-em-track]').forEach(form=>{form.onsubmit=e=>{e.preventDefault();const number=form.querySelector('input').value.trim();if(number)window.open('https://t.17track.net/en#nums='+encodeURIComponent(number),'_blank','noopener');};});
    document.querySelectorAll('.emberante-legacy scroll-to-top-button').forEach(button=>{button.onclick=()=>window.scrollTo({top:0,behavior:'smooth'});});
  };
  init();document.addEventListener('shopify:section:load',init);
})();
customElements.define('emberante-cart-timer',class extends HTMLElement{
  connectedCallback(){
    let end;try{end=Number(sessionStorage.getItem('emberante-cart-countdown'));}catch{}
    if(!end){end=Date.now()+Number(this.dataset.duration)*1000;try{sessionStorage.setItem('emberante-cart-countdown',String(end));}catch{}}
    const update=()=>{const left=Math.max(0,Math.ceil((end-Date.now())/1000));const target=this.querySelector('[data-timer]');if(target)target.textContent=`${Math.floor(left/60)}:${String(left%60).padStart(2,'0')}`;if(!left)clearInterval(this.interval);};
    update();this.interval=setInterval(update,1000);
  }
  disconnectedCallback(){clearInterval(this.interval);}
});
if (!customElements.get('internal-video')) customElements.define('internal-video',class extends HTMLElement{
  connectedCallback(){
    const video=this.querySelector('video');if(!video)return;
    video.querySelectorAll('source[data-src]').forEach(source=>{source.src=source.dataset.src;source.removeAttribute('data-src');});video.load();
    this.onclick=e=>{if(e.target.closest('.internal-video__sound-btn')){video.muted=!video.muted;this.classList.toggle('internal-video--muted',video.muted);}else{if(video.paused)video.play().catch(()=>{});else video.pause();}};
    video.onplay=()=>this.classList.add('internal-video--playing');video.onpause=()=>this.classList.remove('internal-video--playing');
    if(this.dataset.autoplay==='true'){video.muted=true;video.play().catch(()=>{});}
  }
});
